import { YupAnyObject } from '../YupAnyObject';
import { yup } from '../initYup';
import { ParentDepsKey } from './parentWhen';

declare module 'yup' {
  interface ObjectSchema<
    TIn extends yup.Maybe<yup.AnyObject>,
    TContext = yup.AnyObject,
    TDefault = any,
    TFlags extends yup.Flags = '',
  > {
    /**
     * Consolida le dipendenze dei figli per portarle nelle `deps` del
     * padre
     */
    addChildrenParentDeps(): this;
  }
}

/**
 * Funzione che aggiunge le dipendenze dei figli al padre
 */
yup.addMethod<yup.ObjectSchema<YupAnyObject, YupAnyObject>>(
  yup.object,
  'addChildrenParentDeps',
  function (this: yup.ObjectSchema<YupAnyObject, YupAnyObject>) {
    const children = Object.values(this.fields);
    const deps = children.flatMap(field => {
      if (yup.Reference.isRef(field)) return [];
      const meta = getSchemaMeta(field);
      const parentDeps = meta?.[ParentDepsKey] ?? [];
      return (
        parentDeps.map((dep: string) => dep?.split('.').slice(1).join('.')) ??
        []
      );
    });

    // Aggiungiamo le dipendenze, ma non abbiamo bisogno di modificare lo schema
    return this.when(deps, (_, schema) => schema);
  },
);

function getSchemaMeta(schema: yup.ISchema<any>) {
  if ((schema as any).spec?.meta != null) {
    return (schema as any).spec.meta as Record<string, any>;
  }
}
